import { render } from "./CancerDetail.vue?vue&type=template&id=2a48edb8"
import script from "./CancerDetail.vue?vue&type=script&lang=js"
export * from "./CancerDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__